import React from "react";
import cardStyles from "../fachoberschule/Card.module.css";
import {TbTargetArrow} from "react-icons/tb";
import {FaCircleCheck, FaRegHourglassHalf} from "react-icons/fa6";
import {GoPerson} from "react-icons/go";
import {LuBookOpenText} from "react-icons/lu";
import {IoDocumentTextOutline} from "react-icons/io5";
import {FaRegCalendarCheck} from "react-icons/fa";
import {BsClockHistory} from "react-icons/bs";
import {GrVulnerability} from "react-icons/gr";
import { LuAlarmClock } from "react-icons/lu";
import styles from "./Übersicht.module.css";

const features =[
    {
        icon:<TbTargetArrow />,
        title: "Zielgruppe",
        content:<div><p>Absolventen</p>
        <p>der mittleren Reife oder gleichwertiger Abschluss</p></div>,
    },
    {
        icon: <FaRegHourglassHalf />,
        title: "Dauer",
        content: "24 Monate",
    },
    {
        icon: <GoPerson />,
        title: "Praktikum",
        content: "160 Stunden in einem kfm. Betrieb am Ende des ersten Ausbildungsjahres."
    },
    {
        icon:<LuBookOpenText />,
        title: "Schulungsinhalte",
        content: <ul>
            <li> kfm. Grundlagen</li>
            <li>Büromanagement</li>
            <li>Informationsverarbeitung</li>
            <li>Fachkommunikation Englisch</li>
            <li>Deutsch, Politik, Wirtschaft, Sport und Ethik</li>
        </ul>
    },
    {
        icon:<FaCircleCheck />,
        title: "Voraussetzung",
        content:
            <div>
                <p>✔ Abschluss der zweijährigen Berufsfachschule</p>
                <br/>
                <p>✔ mittlere Reife</p>
                <br/>
                <p>✔ die Versetzung in eine gymnasiale Oberstufe</p>
                <br/>
                <p>✔ ein Zeugnis der Fachhochschulreife oder eine als gleichwertig anerkanntes Zeugnis</p>
                <br/>
                <p>✔ Noten:</p>
                <p>Mit mindestens befriedigenden Leistungen in zwei der Fächer Deutsch, Mathematik und Englisch, wobei in keinem der genannten Fächer die Leistungen schlechter als ausreichend sein dürfen</p>
            </div>,
    },
    {
        icon:<IoDocumentTextOutline />,
        title:"Dokumente zur Anmeldung",
        content: <ul>
            <li>Geburtsurkunde</li>
            <li>Bewerbungsschreiben
                Lebenslauf mit Passfoto</li>
            <li>Beglaubigte Kopie über die letzten zwei Halbjahreszeugnisse</li>
            <li>Falls vorhanden das Zeugnis über  die mittlere Reife</li>
            <li>ggf. Einverständniserklärung der Erziehungsberechtigten </li>
        </ul>
    },
    {
        icon:<LuAlarmClock />,
        title: "Anmeldefrist",
        content: "30. April"
    },
    {
        icon: <FaRegCalendarCheck />,
        title: "Beginn",
        content:
            <div><p>10. August 2026</p>
            <p>nach den Sommerferien</p></div>
    },
    {
        icon: <BsClockHistory />,
        title: "Unterrichtszeiten",
        content: "33 -36 Wochenstunden / Montag bis Freitag"
    },
    {
        icon: <GrVulnerability />,
        title: "Ausbildungsziel",
        content:<div><p>staatlich geprüfter</p>
        <p>kfm. Assistent*in</p></div>
    }
];



const FeaturesCard = ({ features }) => (
    <div className={cardStyles.card}>
        <div className={cardStyles.icon}>{features.icon}</div>
        <div className={cardStyles.title}>{features.title}</div>
        <div className={cardStyles.content}>{features.content}</div>

    </div>
);

const Ubersicht = () => {
    return(
  <div className="wrapper">
            <main className={styles.container}>
                <section className="wrapperContent">
                    <div style={{ marginBottom: "80px" }}>
                        <h1 style={{ fontWeight: "bold", color: "#488e62", textAlign: "left", marginBottom: 0 }}>
                          Übersicht
                        </h1>
                    </div>
                </section>
            </main>
            <div className={cardStyles.container}>
                {features.map((features, index) => (
                    <FeaturesCard key={index} features={features} />
                ))}
            </div>
        </div>
    )
}
export default Ubersicht;